import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';

export function OrbitTargetSetter() {
  const { controls } = useThree(); // This will grab the `makeDefault` OrbitControls

  useEffect(() => {
    if (controls) {
      controls.target.set(0, 1, 0);
      controls.update();
    }
  }, [controls]);

  return null;
}
